const tournamentTypes = {
  "single-elimination": {
    name: "Eliminación Directa",
  },
  "double-elimination": {
    name: "Doble Eliminación",
  },
};

export const SINGLE_ELIMINATION = "single-elimination";
export const DOUBLE_ELIMINATION = "double-elimination";
export const GROUP_STAGE_ONLY = "group-stage-only";
export const ROUND_ROBIN = "round-robin";
export const FOUR_PLAYER_TWO_ROUNDS = "four-player-two-rounds";
export const SECOND_ROUND_SAME_RESULT = "same_result";
export const SECOND_ROUND_CROSS_RESULT = "cross_result";
export const AMERICANO = "americano";
export const LEAGUE = "league";

tournamentTypes[LEAGUE] = {
  name: "Liga",
};

export default tournamentTypes;
